/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {KTIcon} from '../../../../../_metronic/helpers'
import {ErrorMessage, Field} from 'formik'
import { reg } from '../components/lista_regiones_zona'
import Througputchart from '../components/widgetThroughputh'
import { Resumensolicitud } from '../components/Modalversion'

type objetocontinente ={
  name: string,
  code: string,
  type: string,
  label: string,
 continent: string
}






type VPN= {
  Cantidad:string,
  Connectcap:string,
  total:number
}



type Edge= {
  opcionEdge:string,
  cantidadedge:string,
  capacidadedge:string,
  totaledge:number
}

type VRFs={
  VRF_name:string,
}

type Resumen={
  cloud:string,
  tipo_locacion:string,
  continente:string,
  region:string,
  type_ctx:string,
  Throughput:string,
  listVPNcon:VPN[],
  listCloudConnIntra:Intraregion[],
  listCloudConnInter:InterRegion[],
  listCEdgeConn:Edge[],
  listVRF:VRFs[],
  Security:string[]
}

type Intraregion ={
  CapacidadIntra:string,
  ConexionIntra:string,
  RegionIntra:string,
  availability:string,
}

type InterRegion ={
  CapacidadInterReg:string,
  ConexionInterReg:string,
  LocacionInter:string,
  ContinenteInterreg:string,
  ZonaInter:string, 
}
export default function Step1(props:any) {
  /*****************CONSTANTES******************** */
  const [cloud,setcloud] = useState('')
  const [loctype,setloctype] =useState('')
  const [continente,setcontinente]= useState('')
  const [region,setRegion]=useState('')
  const [listaSelectContinente,setcontinentes]= useState<objetocontinente[]>([])
  const [listaRegion,setlistaRegion]= useState<objetocontinente[]>([])
  const [type_ctx,setTypectx]= useState('');
  const [Throughput,setThroughput]= useState('');
  const [CantidadConnectorVPN,setCantidad]= useState('')
  const [ConnectVPNcap,setConnectcap]=useState('');
  const [ConnectCloudCap,setcapCloud]= useState('')
  const [opcionEdge,setOpcionEdge] = useState('');
  const [ConnectorEdgeCap,setconnectorEdgecap]=useState('')
  const [CantidadConnectorEdge,setCantidadedge]= useState('')
  const [VRF_name,setvrfName]=useState('');

  const [conexionCloud,setConexionCloud]= useState('')

  const [listaRegionIntraRegion,setlistaRegionIntraregion]= useState<objetocontinente[]>([])
  const [regionIntrareg,setregionIntrareg]=useState('')
  const [AvailabilityZone,setAvailabilityZones]=useState('')

  
  const [loctypeInter,setloctypeInter] =useState('')
  const [listacontinentesIntercloud,setcontinentesintercloud]= useState<objetocontinente[]>([])
  const [listaregiter,setlistareginter]= useState<objetocontinente[]>([])
  const [continenteInter,setcontinenteInter]= useState('')
  const [regionInter,setregionconexionloud]=useState('')




 
  


  /*******************SELECTORES DE REGION Y LOCALZONE***************************** */

  const listadecontinentes:Array<object>=[]
    listadecontinentes.push(Object.keys(reg))
  
  const listadeobjetoscontinentes:Array<any>=[]
  listadeobjetoscontinentes.push(Object.values(reg))


  useEffect( () => {
    //listadeZonas.splice(0,listadeZonas.length)
    const lista=[]
    for (const continenteindividual of listadeobjetoscontinentes){
      for (const y of continenteindividual){
        if(loctype === y.type){
          lista.push(y.name)
          }
      }
    }
    setcontinentes(lista)
  }, [loctype])
 
  useEffect( () => {
    //listadeZonas.splice(0,listadeZonas.length)
    const listareg=[]
    for (const continenteindividual of listadeobjetoscontinentes){
      for (const R of continenteindividual){
        if(continente === R.name){
          listareg.push(R.code)
          }
      }
    }
    setlistaRegion(listareg)
  }, [continente])

  useEffect( () => {
    const listacontieneteconex=[]
    for (const continenteindividual of listadeobjetoscontinentes){
      for (const x of continenteindividual){
        if(loctypeInter === x.type){
          if (!x.code.includes(region.split('-')[0]+'-'+region.split('-')[1]+'-'+region.split('-')[2])){
            listacontieneteconex.push(x.name)
          }
        }
      }
    
    }
    setcontinentesintercloud(listacontieneteconex)
  }, [loctypeInter])

  useEffect( () => {
    //listadeZonas.splice(0,listadeZonas.length)
    const listaregInter=[]
    for (const continenteindividual of listadeobjetoscontinentes){
      for (const Regs of continenteindividual){
        if(continenteInter === Regs.name){
          listaregInter.push(Regs.code)
          }
      }
    }
    setlistareginter(listaregInter)
  }, [continenteInter])

  useEffect( () => {
    //listadeZonas.splice(0,listadeZonas.length)
    const listaregavailabilityzone =[]
    for (const continenteindividual of listadeobjetoscontinentes){
      for (const availablezone  of continenteindividual){
        if(availablezone.code.includes(region.split('-')[0]+'-'+region.split('-')[1]+'-'+region.split('-')[2])){
          listaregavailabilityzone.push(availablezone)
          }
      }
    }
    setlistaRegionIntraregion(listaregavailabilityzone)
  }, [region])


  /*******************AGREGAR CONTADOR PARA HACER SUMA TOTAL***************************** */
  const [counter, setCounter] = useState(0)

  const [listVPNcon,setlistVPNcon]= useState<VPN[]>([])
  const [listCloudConn,setlistCloudConn]= useState <Intraregion[]>([])
  const [listCloudConnInter,setlistCloudConnInter]= useState <InterRegion[]>([])
  const [listCEdgeConn,setlistEdgeConn]= useState <Edge[]>([])
  const [listVRF,setlistVRF]= useState <VRFs[]>([])


    const handleClick1 = () => {
      // Counter state is incremented
      setCounter(counter + (Number(ConnectVPNcap)*Number(CantidadConnectorVPN)))
      setlistVPNcon([...listVPNcon,{
        Connectcap:ConnectVPNcap,
        Cantidad:CantidadConnectorVPN,
        total:(Number(ConnectVPNcap)*Number(CantidadConnectorVPN))
      }])
  
    }

    const handleClick2 = (capacidad:any,id:any) => {
      // Counter state is incremented
      if(counter !==0){
      setCounter(counter - Number(capacidad))}
      listVPNcon.splice(id,1)
    }

    const handleClick3 = () => {
      // Counter state is incremented
      setCounter(counter + (Number(ConnectCloudCap)))
      if (conexionCloud ==='IntraRegion'){
      setlistCloudConn([...listCloudConn,{
        CapacidadIntra:ConnectCloudCap,
        ConexionIntra:conexionCloud,
        RegionIntra:regionIntrareg,
        availability:AvailabilityZone,
      }])}

      if(conexionCloud=== 'InterRegion'){
        setlistCloudConnInter([...listCloudConnInter,{
          CapacidadInterReg:ConnectCloudCap,
          ConexionInterReg:conexionCloud,
          LocacionInter:loctypeInter,
          ContinenteInterreg:continenteInter,
          ZonaInter:regionInter
        }])
      }
      
      //setregionIntrareg('')
      //setAvailabilityZones('')
    }

    const handleClick4 = (capacidadcloud:any,idcloud:any) => {
      // Counter state is incremented
      if(counter !==0){
      setCounter(counter - Number(capacidadcloud))}
      listCloudConn.splice(idcloud,1)      
    }

    const handleClick4B = (capacidadcloudInter:any,idcloud:any) => {
      // Counter state is incremented
      if(counter !==0){
      setCounter(counter - Number(capacidadcloudInter))}
      listCloudConnInter.splice(idcloud,1)      
    }

    const handleClick5 = () => {
      // Counter state is incremented
      setCounter(counter + (Number(ConnectorEdgeCap)* Number(CantidadConnectorEdge)))
      setlistEdgeConn([...listCEdgeConn,{
      opcionEdge:opcionEdge,
      cantidadedge:CantidadConnectorEdge,
      capacidadedge:ConnectorEdgeCap,
      totaledge:(Number(ConnectorEdgeCap)*Number(CantidadConnectorEdge))
      }])
      setconnectorEdgecap('')
    }

    const handleClick6 = (capacidadEdge:any,idedge:any) => {
      // Counter state is incremented
      if(counter !==0){
      setCounter(counter - Number(capacidadEdge))}
      listCEdgeConn.splice(idedge,1)
    }

    const handleClick7 = () => {
      // Counter state is incremented
      setlistVRF([...listVRF,{
      VRF_name:VRF_name,
      }])
      setvrfName('')
    }

    const handleClick8 = (idVRF:any) => {
      // Counter state is incremented
      listVRF.splice(idVRF,1)
      setlistVRF([...listVRF])
        }





  /*******************HACER CHECK EN OPCIÓN PARA CLOUD PEERING ***************************** */
  
  
  

 useEffect( () => {
  //listadeZonas.splice(0,listadeZonas.length)
   if(conexionCloud === 'IntraRegion'){
    setregionIntrareg(region.split('-')[0]+'-'+region.split('-')[1]+'-'+region.split('-')[2])
  }
}, [conexionCloud])


  /////////////////////////
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

     
  const handleCheckboxChangesecurity = (event:any) => {
   const { value, checked } = event.target;
   
   if (checked) {
       setSelectedItems((prevSelectedItems:Array<string>) => [...prevSelectedItems, value]);
   } else {
       setSelectedItems((prevSelectedItems:Array<string>) =>
           prevSelectedItems.filter((item) => item !== value)
       );
   }
};

  /******************* SELECCIONAR UNA OPCION DE CONECTOR EDGE ***************************** */
  const conectoredge=[{
    id:1,
    cloud: 'AWS',
    option: 'AWS Direct Connect',
    description: 'With this connection, you can create virtual interfaces directly to public AWS services or to Amazon VPC.'
  },
  {
    id:2,
    cloud: 'GCP',
    option: 'GCP Partner Interconnect',
    description: 'Partner interconnection provides connectivity between your local network and your virtual private cloud (VPC) network.'
  },
  {
    id:3,
    cloud:'AZR',
    option: 'Azure Express Route',
    description: 'ExpressRoute connections do not go over the public Internet. This allows ExpressRoute connections to offer more reliable, faster, and more secure connections.'
  },
  {
    id:4,
    cloud:'OCI',
    option: 'Oracle Fast Connect',
    description: 'FastConnect allows you to connect directly to your virtual cloud network in Oracle Cloud Infrastructure (OCI) through dedicated, private, high-bandwidth connections.'
  }
]

const Security=[{
  id:1,
  name:'Intrusion Prevention'
},
{
  id:2,
  name:'Advanced Malware'
},
{
  id:3,
  name:'Security Rating'
},
{
  id:4,
  name:'DLP'
},
{
  id:5,
  name:'AI Bases Inline Sandbox'
},
{
  id:6,
  name:'WEB, DNS & Vide Filtering'
},
{
  id:7,
  name:'Cloud Security Posture'
}]
 //************************************************************************************** */
 const [loading, setLoading] = useState(false);

 const[resumen,setresumen]= useState <Resumen>()


 const handleSubmit =async (e:any) => {
  e.preventDefault();
  setresumen({
    cloud:cloud,
    tipo_locacion:loctype,
    continente:continente,
    region:region,
    type_ctx:type_ctx,
    Throughput:Throughput,
    listVPNcon:listVPNcon,
    listCloudConnIntra:listCloudConn,
    listCloudConnInter:listCloudConnInter,
    listCEdgeConn:listCEdgeConn,
    listVRF:listVRF,
    Security:selectedItems
  })

 }
 /************************************* */
 useEffect( () => {
  if (props.paso===2|| props.paso===1){ 
   props.set(
   { cloud:cloud,
     tipo_locacion:loctype,
     continente:continente,
     region:region,
     type_ctx:type_ctx,
     Throughput:Throughput,
     listVPNcon:listVPNcon,
     listCloudConnIntra:listCloudConn,
     listCloudConnInter:listCloudConnInter,
     listCEdgeConn:listCEdgeConn,
     listVRF:listVRF,
     Security:selectedItems,
     Total_trhoug:counter}
   )}
   else{
     props.set('')
   }

 }, [props.paso,counter])


  return (
    <div className='w-100'>
      <div className='pb-10 pb-lg-15 text-center'>
        <h2 className='fw-bolder  align-items-center text-center text-dark'>
          Do you need a new CTX?
          <i
            className='fas fa-exclamation-circle ms-2 fs-7'
            data-bs-toggle='tooltip'
            title='If you need a new CTX let us know the features you need by filling out the form below.'
          ></i>
        </h2>

        <div className='text-gray-400 fw-bold fs-6'>
          If you need a new CTX let us know the features you need by <strong>filling out</strong> the form below.
        </div>
      </div>

      <div className='fv-row '>
        <div className='row '>
          <div className='col-lg-3'>
            <label className='form-label fs-6 fw-bolder text-dark required form-label' >Select Cloud</label>
            <select 
                style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                required
                className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                value={cloud}
                onChange={(e) => setcloud((e.target.value))}
                >
                <option  key={'0'} hidden> Select cloud</option>
                <option key={'1'} className="text-info" value="AWS">AWS</option>
                <option key={'2'}className="text-info" value="OCI">OCI</option>
                <option key={'3'}className="text-info" value="AZR">AZR</option>
                <option key={'4'}className="text-info" value="GCP">GCP</option>
              </select>
          </div>
          <div className='col-lg-3'>
            <label className='form-label fs-6 fw-bolder text-dark required form-label' >Location type</label>
            <select 
                style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                required
                className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                value={loctype}
                onChange={(e) => setloctype((e.target.value))}
                >
                <option  hidden> Select type</option>
                {cloud ==='AWS'&&
                <>
                <option className="text-info" value="AWS Region">Region</option>
                <option className="text-info" value="AWS Local Zone">Local Zone</option>
                <option className="text-info" value="AWS Wavelength Zone">Wavelength Zone</option>
                </>}
              </select>
          </div>
          <div className='col-lg-3'>
            <label className='form-label fs-6 fw-bolder text-dark required form-label' >Select Continent</label>
            <select 
                style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                required
                className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                value={continente}
                onChange={(e) => setcontinente((e.target.value))}
                >
                <option className="text-info" hidden >Choose Continent</option>
                {cloud ==='AWS'&& listaSelectContinente.map((a:any,i:any)=>
                  <option key={i}className="text-info" value={a}>{a}</option>
                )}
              </select>
          </div>
          
          <div className='col-lg-3'>
            {continente ===''&& <label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose</label>}
            {continente !==''&& loctype === "AWS Region" &&<label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Region</label>}
            {continente !==''&& loctype === "AWS Local Zone" &&<label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Local Zone</label>}
            {continente !==''&& loctype === "AWS Wavelength Zone" &&<label className='form-label fs-6 fw-bolder text-dark required form-label' >Wavelength Zone</label>}
            <select 
                style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                required
                className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                value={region}
                onChange={(e) => setRegion((e.target.value))}
                >
                <label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Region</label>
                <option  hidden> Select Region</option>
                {cloud ==='AWS'&& listaRegion.map((reg:any,i:any)=>
                  <option key={i}className="text-info" value={reg}>{reg}</option>
                )}
              </select>
          </div>
        </div>
      </div>
      <br />
    {/******************************************* */}
    <div className='fv-row '>
          <div className='row '>
          {Throughput.length !==0 && Number(counter) <= Number(Throughput)&&
            <Througputchart
                exedido={0}
                name='IpSec connector'
                total= {Number(Throughput)}
                disponible={Number(Throughput)-Number(counter)}
                className='card-xl-stretch mb-xl-8'
                chartColor='info'
                chartHeight={250}
                
                ></Througputchart> 
              }

            {Throughput.length !==0 && Number(counter) > Number(Throughput)&&
            <Througputchart
                exedido={Number(counter)}
                name='IpSec connector'
                total= {Number(Throughput)}
                disponible={Number(Throughput)-Number(counter)}
                className='card-xl-stretch mb-xl-8'
                chartColor='danger'
                chartHeight={250}
 
                ></Througputchart> 
              }
          </div>
        </div>


    {/******************************************* */}
      <div className='fv-row '>
        <div className='row '>
          <div className='col-lg-6'>
            <label className='form-label fs-6  text-dark required form-label' >Choose CTX Type</label>
            <select 
                style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                required
                className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                value={type_ctx}
                onChange={(e) => setTypectx((e.target.value))}>
                    <option  hidden> Select plan</option>
                    <option className="text-info" value="Connect">Connect</option>
                    <option className="text-info" value="Protect">Protect</option>
                    <option className="text-info" value="Advanced">Advanced</option>
              </select>  
          </div>
          
          <div className='col-lg-6'>
            <label className='form-label fs-6 text-dark required form-label'>Select Throughput</label>
            <select 
              style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
              required
              className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
              value={Throughput}
              onChange={(e) => setThroughput((e.target.value))}>
                <option  hidden>Gbps</option>
                { type_ctx === 'Connect'?
                <>
                <option className="text-info" value="1000">1 Gbps</option>
                <option className="text-info" value="2500">2.5 Gbps</option>
                <option className="text-info" value="5000">5 Gbps</option>
                <option className="text-info" value="10000">10 Gbps</option>
                </>: type_ctx === 'Protect'?
                <>
                <option className="text-info" value="1000">1 Gbps</option>
                <option className="text-info" value="2500">2.5 Gbps</option>
                <option className="text-info" value="5000">5 Gbps</option>
                <option className="text-info" value="10000">10 Gbps</option>
                </>:
                type_ctx === 'Advanced'?
                <>
                <option className="text-info" value="1000">1 Gbps</option>
                <option className="text-info" value="2500">2.5 Gbps</option>
                <option className="text-info" value="5000">5 Gbps</option>
                <option className="text-info" value="10000">10 Gbps</option>
                <option className="text-info" value="25000">25 Gbps</option>
                <option className="text-info" value="40000">40 Gbps</option>
                </>:
                <>
                <option className="text-danger" value="">Please select a plan</option>
                </>
                }
          </select>                
          </div>

        </div>
      </div>
      <br />

      <div className='fv-row '>
        <div className='row '>
           {/* Campos solicitud VPN connector */}
           <div className='fv-row mb-3'>
              <div className='accordion' id='kt_accordion_1'>
                  <div className='accordion-item'>
                    <h2 className='accordion-header' id='kt_accordion_1_header_1'>
                      <button
                        className='accordion-button fs-4 fw-bold collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#kt_accordion_1_body_1'
                        aria-expanded='false'
                        aria-controls='kt_accordion_1_body_1'
                      >
                        VPN Connector
                      </button>
                    </h2>
                    <div
                      id='kt_accordion_1_body_1'
                      className='accordion-collapse collapse'
                      aria-labelledby='kt_accordion_1_header_1'
                      data-bs-parent='#kt_accordion_1'
                    >
                      <div className='accordion-body'>
                        {/******************************* */}
                        <div className="d-flex flex-row-fluid flex-column-fluid ">
                            <div className=" flex-row-fluid  flex-center col-5">
                              <label className='form-label fs-6 fw-bolder text-dark required form-label'>Connector Size</label>
                              <select 
                                  style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                                  required
                                  className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                                  value={ConnectVPNcap}
                                  onChange={(e) => setConnectcap((e.target.value))}>
                                      <option  hidden>Select Throughput</option>
                                      <option className="text-info" value="250">250 Mbps</option>
                                      <option className="text-info" value="500">500 Mbps</option>
                                      <option className="text-info" value="1250">1.25 Gbps</option>
                                    
                                </select>                            
                            </div>
                            <div className=" d-flex flex-row-fluid  flex-center col-5 ">
                              <div className='fv-row mb-8'>
                                  <label className='form-label fs-6 fw-bolder text-dark required form-label'>Cantidad</label>
                                  <input 
                                    type="number" 
                                    name='cantidad ctx' 
                                    className='form-control form-control-solid border-primary border-active'
                                    value={CantidadConnectorVPN}
                                    onChange={(e:any) => setCantidad(e.target.value)} 
                                    placeholder='Enter a number'
                                  />                            
                              </div>
                            </div>                                                      
                            <div className=" d-flex flex-row-fluid  flex-center col-5 ">
                              <div className='fv-row mb-8'>
                                 
                                <button type='button'
                                  disabled ={CantidadConnectorVPN ===''}
                                  id='kt_sign_in_submit'
                                  onClick={handleClick1}
                                  className='btn btn-primary'>Add</button>                      
                              </div>
                            </div>
                            
                        </div>
                      
                          {/* begin::Table 1 */}
                          {listVPNcon.length !== 0 &&
                            <div className='card-custom '>
                            <div className='card-header border-0 pt-5'>
                                <h3 className='card-title align-items-start flex-column '>
                                <span className='card-label fw-bold fs-3 mb-1'>VPN Connectors</span>
                                </h3>
                            </div>
                            <div className='card-body py-3 flex-center' >
                              <div className='tab-content'>
                                <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                                    <div className='table-responsive'>

                                  <table className='table table-row-dashed table-row-gray-300 text-center' id='table'>
                                      <thead className='fw-bold text-center text-info'>
                                          <tr className='border-0'>
                                          <th>Connector Size</th>
                                          <th> Cantidad</th>
                                          <th>Total</th>
                                          <th>Actions</th>
                                          </tr>
                                      </thead>
                                      {/* end::Table head */}


                                      {/* begin::Table body */}
                                      <tbody className='text-center '>
                                          {listVPNcon.map((d:any,i:any)=>(
                                              <tr key={i}>           
                                                <td>{d.Connectcap}</td> 
                                                <td>{d.Cantidad}</td>
                                                <td>{d.total}</td>
                                                <td>
                                                  <button type='button'
                                                    id='kt_sign_in_submit'
                                                    onClick={()=> handleClick2(d.total,i)}
                                                    className='btn btn-primary'>Delete
                                                  </button>
                                                </td>
                                              </tr>
                                          ))
                                          }

                                      </tbody>
                                        {/* end::Table body */}
                                  </table>
                                        {/* end::Table */}
                                    </div>
                                </div>
                                {/* end::Tap pane */}
                                </div>
                            </div>              
                          </div>}
                          {/* end::Table 1 */}
                      </div>
                      
                    </div>
                  </div>
                </div>  
          
          </div>
        </div>
      </div>

      {/* Campos solicitud Cloud Peering Connector*/}
      <div className='fv-row '>
        <div className='row '>
          <div className='fv-row mb-3'>
            <div className='accordion' id='kt_accordion_2'>
              <div className='accordion-item'>
                <h2 className='accordion-header' id='kt_accordion_2_header_1'>
                  <button
                    className='accordion-button fs-4 fw-bold collapsed'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_accordion_2_body_1'
                    aria-expanded='false'
                    aria-controls='kt_accordion_2_body_1'
                  >
                    Cloud Peering Connector
                  </button>
                </h2>
                <div
                  id='kt_accordion_2_body_1'
                  className='accordion-collapse collapse'
                  aria-labelledby='kt_accordion_2_header_1'
                  data-bs-parent='#kt_accordion_2'
                >
                  <div className='accordion-body'>
                  <div className="d-flex flex-row-fluid flex-column-fluid ">
                        <div className=" flex-row-fluid  flex-center col-5">
                          <label className='form-label fs-6 fw-bolder text-dark required form-label'>Connector Size</label>
                          <select 
                            style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                            required
                            className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                            value={ConnectCloudCap}
                            onChange={(e) => setcapCloud((e.target.value))}>
                                <option  hidden>Throughput for connector</option>
                                <option className="text-info" value="100">100 Mbps</option>
                                <option className="text-info" value="250">250 Mbps</option>
                                <option className="text-info" value="500">500 Mbps</option>
                                <option className="text-info" value="1250">1.25 Gbps</option>
                                <option className="text-info" value="2500">2.5 Gbps</option>
                                <option className="text-info" value="5000">5 Gbps</option>
                                <option className="text-info" value="10000">10 Gbps</option>
                                {type_ctx ==='Advanced'&&<>
                                <option className="text-info" value="25000">25 Gbps</option>
                                <option className="text-info" value="40000">40 Gbps</option>
                                </>}
                          </select>                          
                        </div>                                                   
                    </div>
                    <br />
                    {/**************selecciones cloud opciones **************************/}
                    <div className='fv-row'>
                      <div className='row'>
                        <div className='col-lg-6'>
                          <div className="form-check form-check-custom form-check-solid flex-center">
                            <input className="form-check-input" 
                            name='cloudpeering'
                            type="radio" 
                            value="IntraRegion" 
                            id="flexRadioChecked" 
                            onChange={(e:any) => setConexionCloud(e.target.value)} />
                            <label className="form-check-label" >
                                Intra Region
                            </label>
                          </div>
                        </div>


                        <div className='col-lg-6'>
                          <div className="form-check form-check-custom form-check-solid">
                            <input className="form-check-input" 
                              name='cloudpeering'
                              type="radio" 
                              value="InterRegion" 
                              id="flexRadioChecked" 
                              onChange={(e:any) => setConexionCloud(e.target.value)} />
                            <label className="form-check-label" >
                                Inter Region
                            </label>
                          </div>
                          </div>
                          <br />
                          <br />

                          {conexionCloud !=='' && conexionCloud ==='IntraRegion'&&
                          <div className='fv-row '>
                            <div className='row '>
                            <div className='col-lg-6'>
                              <label className='form-label fs-6 fw-bolder text-dark form-label' >Region</label>
                              <select 
                                  style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                                  required
                                  disabled
                                  className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                                  value={regionIntrareg}
                                  onChange={(e) => setregionIntrareg((e.target.value))}
                                  >
                                  <option className="text-info" hidden >Choose Continent</option>
                                    <option key='a' className="text-info" value={regionIntrareg}>{regionIntrareg}</option>
                                </select>
                            </div>
                            
                            <div className='col-lg-6'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label' >Availability Zones</label>
                              <select 
                                  style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                                  required
                                  className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                                  value={AvailabilityZone}
                                  onChange={(e) => setAvailabilityZones((e.target.value))}
                                  >
                                  <label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Region</label>
                                  <option  hidden> Select Availability Zone</option>
                                  {cloud ==='AWS'&& listaRegionIntraRegion.map((reg:any,i:any)=>
                                    <option key={i}className="text-info" value={reg.code}>{reg.code} / {reg.label}</option>
                                  )}
                                </select>
                            </div>
                            </div>
                          </div>}

                          {conexionCloud !=='' && conexionCloud ==='InterRegion'&&
                          <div className='fv-row '>
                            <div className='row '>
                              <div className='col-lg-4'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label' >Location type</label>
                              <select 
                                  style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                                  required
                                  className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                                  value={loctypeInter}
                                  onChange={(e) => setloctypeInter((e.target.value))}
                                  >
                                  <option  hidden> Select type</option>
                                  {cloud ==='AWS'&&
                                  <>
                                  <option className="text-info" value="AWS Region">Region</option>
                                  <option className="text-info" value="AWS Local Zone">Local Zone</option>
                                  <option className="text-info" value="AWS Wavelength Zone">Wavelength Zone</option>
                                  </>}
                                </select>
                            </div>
                            <div className='col-lg-4'>
                              <label className='form-label fs-6 fw-bolder text-dark required form-label' >Select Continent</label>
                              <select 
                                  style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                                  required
                                  className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                                  value={continenteInter}
                                  onChange={(e) => setcontinenteInter((e.target.value))}
                                  >
                                  <option className="text-info" hidden >Choose Continent</option>
                                  {cloud ==='AWS'&& listacontinentesIntercloud.map((a:any,i:any)=>
                                    <option key={i}className="text-info" value={a}>{a}</option>
                                  )}
                                </select>
                            </div>
                            
                            <div className='col-lg-4'>
                              {continente ===''&& <label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose</label>}
                              {continente !==''&& loctype === "AWS Region" &&<label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Region</label>}
                              {continente !==''&& loctype === "AWS Local Zone" &&<label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Local Zone</label>}
                              {continente !==''&& loctype === "AWS Wavelength Zone" &&<label className='form-label fs-6 fw-bolder text-dark required form-label' >Wavelength Zone</label>}
                              <select 
                                  style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                                  required
                                  className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                                  value={regionInter}
                                  onChange={(e) => setregionconexionloud((e.target.value))}
                                  >
                                  <label className='form-label fs-6 fw-bolder text-dark required form-label' >Choose a Region</label>
                                  <option  hidden> Select Region</option>
                                  {cloud ==='AWS'&& listaregiter.map((reg:any,i:any)=>
                                    <option key={i}className="text-info" value={reg}>{reg}</option>
                                  )}
                                </select>
                            </div>
                            </div>
                          </div>}


                          
                      </div>
                    </div>
                    {/*************************************************** */}                       
                    <br />
                    
                    <button
                      type='button'
                      id='kt_sign_in_submit'
                      onClick={handleClick3}
                      className='btn btn-primary text-center'> Add
                    </button>

                      {/* begin::Table 2 */}
                    {listCloudConn.length !== 0 &&
                        <div className='card-custom'>
                        <div className='card-header border-0 pt-5'>
                            <h3 className='card-title align-items-start flex-column '>
                            <span className='card-label fw-bold fs-3 mb-1'>Cloud Peering Connectors Intra Region</span>
                            </h3>
                        </div>
                        <div className='card-body py-3'>
                            <div className='tab-content'>
                            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                                <div className='table-responsive'>

                                    
                                    <table className=' table table-row-dashed table-row-gray-300 text-center' id='table'>
                                    <thead className='fw-bold text-info'>
                                      <tr>
                                        <th>Conection Type</th> 
                                        <th>Region</th>
                                        <th>Availability Zones</th>
                                        <th>Connector Size</th>
                                        <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      {listCloudConn.length !== 0 && listCloudConn?.map((d,i)=>(
                                        <tr key={i}>
                                          <td>{d.ConexionIntra}</td>
                                          <td>{d.RegionIntra}</td>
                                          <td>{d.availability}</td>
                                          <td>{d.CapacidadIntra}</td>
                                          <td><button type='button'
                                          id='kt_sign_in_submit'
                                          onClick={()=> handleClick4(d.CapacidadIntra,i)}
                                          className='btn btn-primary'>Delete</button></td>
                                        </tr>))}
                                      </tbody>

                                    </table>
                                    {/* end::Table */}
                                </div>
                            </div>
                            {/* end::Tap pane */}
                            </div>
                        </div>              
                      </div>}
                      {/* end::Table 2 */}
                    {/* begin::Table 2B */}
                    {listCloudConnInter.length !== 0 &&
                        <div className='card-custom'>
                        <div className='card-header border-0 pt-5'>
                            <h3 className='card-title align-items-start flex-column '>
                            <span className='card-label fw-bold fs-3 mb-1'>Cloud Peering Connectors Inter Region</span>
                            </h3>
                        </div>
                        <div className='card-body py-3'>
                            <div className='tab-content'>
                            <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                                <div className='table-responsive'>

                                    
                                    <table className=' table table-row-dashed table-row-gray-300 text-center' id='table'>
                                    <thead className='fw-bold text-info'>
                                      <tr>
                                        <th>Conection Type</th> 
                                        <th>Location Type</th>
                                        <th>Continet</th>
                                        <th>Zone</th>
                                        <th>Connector Size</th>
                                        <th>Actions</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                      {listCloudConnInter.length !== 0 && listCloudConnInter?.map((d,i)=>(
                                        <tr key={i}>
                                          <td>{d.ConexionInterReg}</td>
                                          <td>{d.LocacionInter}</td>
                                          <td>{d.ContinenteInterreg}</td>
                                          <td>{ d.ZonaInter}</td>
                                          <td>{d.CapacidadInterReg}</td>
                                          <td><button type='button'
                                          id='kt_sign_in_submit'
                                          onClick={()=> handleClick4B(d.CapacidadInterReg,i)}
                                          className='btn btn-primary'>Delete</button></td>
                                        </tr>))}
                                      </tbody>

                                    </table>
                                    {/* end::Table */}
                                </div>
                            </div>
                            {/* end::Tap pane */}
                            </div>
                        </div>              
                      </div>}
                      {/* end::Table 2B */}

                    
                  
                  </div>
                </div>
              </div>
            </div> 
            </div>
        </div>
        </div>
        
        {/* Campos solicitud Edge Peering Connector*/}
        <div className='fv-row mb-3'>
          <div className='accordion' id='kt_accordion_3'>
            <div className='accordion-item'>
              <h2 className='accordion-header' id='kt_accordion_3_header_1'>
                <button
                  className='accordion-button fs-4 fw-bold collapsed'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#kt_accordion_3_body_1'
                  aria-expanded='false'
                  aria-controls='kt_accordion_3_body_1'
                >
                  Edge Peering Connector
                </button>
              </h2>
              <div
                id='kt_accordion_3_body_1'
                className='accordion-collapse collapse'
                aria-labelledby='kt_accordion_3_header_1'
                data-bs-parent='#kt_accordion_3'
              >
                <div className='accordion-body'>
                  <h4 className='text-center text-info'>Choose a dedicated network provider</h4>
                  {conectoredge.map((n:any)=>(
                    n.cloud ===cloud &&
                  <>
                  <div className='d-flex fv-row'>
                  <div className='form-check form-check-custom form-check-solid'>

                   <input
                    className='form-check-input me-3'
                    name='role'
                    type='radio'
                    id='rol'
                    value={n.option}
                    onChange={(e:any) => setOpcionEdge(e.target.value)}
                  />

                  <label className='form-check-label' htmlFor='kt_modal_update_role_option_0'>
                    <div className='fw-bolder text-gray-800'>{n.option}</div>
                    <div className='text-gray-600'>
                      {n.description}
                    </div>
                  </label>
                  </div>
                  </div>
                  <div className='separator separator-dashed my-5'></div>
                  </>
                ))}

             
                <label className='form-label fs-6  text-dark fw-bolder form-label' >Connectro Size</label>
                <select 
                  style={{height:'37.15px',paddingTop:'0', paddingBottom:'0'}}
                  required
                  className="form-select form-select-solid bg-light-info text-info border-gray-400 " aria-label="Select example"
                  value={ConnectorEdgeCap}
                  onChange={(e) => setconnectorEdgecap((e.target.value))}>
                      <option  hidden>Throughput for connector</option>
                      <option className="text-info" value="500">500 Mbps</option>
                      <option className="text-info" value="1250">1.25 Gbps</option>
                      <option className="text-info" value="2500">2.5 Gbps</option>
                      <option className="text-info" value="5000">5 Gbps</option>
                      <option className="text-info" value="10000">10 Gbps</option>
                      {type_ctx ==='Advanced'&&<>
                        <option className="text-info" value="25000">25 Gbps</option>
                        <option className="text-info" value="40000">40 Gbps</option>
                        </>}
                  </select> 
                  <br />

                  <label className='form-label fs-6 fw-bolder text-dark required form-label'>Cantidad</label>
                  <input 
                    type="number" 
                    name='cantidad ctx' 
                    className='form-control form-control-solid border-primary border-active'
                    value={CantidadConnectorEdge}
                    onChange={(e:any) => setCantidadedge(e.target.value)} 
                    placeholder='Enter a number'
                  /> 
                  <br />      
                   
                    <button
                      disabled={CantidadConnectorEdge ===''}
                      type='button'
                      id='kt_sign_in_submit'
                      onClick={handleClick5}
                      className='btn btn-primary text-center'> Add
                    </button>

                {/* begin::Table 3 */}
                  {listCEdgeConn.length !== 0 &&
                  <div className='card-custom'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>Edge Peering Connectors</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className=' table table-row-dashed table-row-gray-300 text-center' id='table'>
                              <thead className='fw-bold text-info'>
                                <tr>
                                <th>Network Provider</th>
                                <th>Connector Size</th>
                                <th>Cantidad</th>
                                <th>Total</th>
                                <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                              {listCEdgeConn.length !== 0 && listCEdgeConn?.map((d,i)=>(
                                <tr key={i}>
                                  <td>{d.opcionEdge}</td>
                                  <td>{d.capacidadedge}</td>
                                  <td>{d.cantidadedge}</td>
                                  <td>{d.totaledge}</td>
                                  <td><button type='button'
                                  id='kt_sign_in_submit'
                                  onClick={()=> handleClick6(d.totaledge,i)}
                                  className='btn btn-primary'>Delete</button></td>
                                </tr>))}
                              </tbody>

                                    {/* end::Table body */}
                              </table>
                              {/* end::Table */}
                          </div>
                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>              
                </div>}
                {/* end::Table 3 */}
            
                
                </div>
        
              </div>
            </div>
          </div>   
            
          </div>

         {/* Campos VRF*/}
         <div className='fv-row mb-3'>
          <div className='accordion' id='kt_accordion_4'>
            <div className='accordion-item'>
              <h2 className='accordion-header' id='kt_accordion_4_header_1'>
                <button
                  className='accordion-button fs-4 fw-bold collapsed'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#kt_accordion_4_body_1'
                  aria-expanded='false'
                  aria-controls='kt_accordion_4_body_1'
                >
                  VRF
                </button>
              </h2>
              <div
                id='kt_accordion_4_body_1'
                className='accordion-collapse collapse'
                aria-labelledby='kt_accordion_4_header_1'
                data-bs-parent='#kt_accordion_4'
              >
                <div className='accordion-body'>
                <h4 className='text-center text-info'> VRF's</h4>
                  <label className='form-label fw-bolder text-dark fs-6 mb-0 required form-label'>VRF Name</label>
                  <input
                    
                    type="text"
                    className="form-control form-control-solid border-primary border-active "
                    placeholder="Enter a VRF name"
                    maxLength={150}
                    id='vrf'
                    value={VRF_name}
                    onChange={(e) => setvrfName(e.target.value)}

                  />
                
                  <br />
                  <button
                    type='button'
                    id='vrf'
                    onClick={handleClick7}
                    className='btn btn-primary text-center'> Add
                  </button>
                  <br />
                  <br />
                  {/* begin::Table 4 */}
                  {listVRF.length !== 0 &&
                  <div className='card-custom'>
                  <div className='card-header border-0 pt-5'>
                      <h3 className='card-title align-items-start flex-column '>
                      <span className='card-label fw-bold fs-3 mb-1'>VRF's</span>
                      </h3>
                  </div>
                  <div className='card-body py-3'>
                      <div className='tab-content'>
                      <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                          <div className='table-responsive'>

                              <table className=' table table-row-dashed table-row-gray-300 text-center' id='table'>
                              <thead className='fw-bold text-info'>
                                <tr>
                                  <th>Name</th>                                  
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                              {listVRF.length !== 0 && listVRF.map((d,i)=>(
                                d.VRF_name !=='' &&
                                <tr key={i}>
                                  <td>{d.VRF_name}</td>
                                  <td><button type='button'
                                  id='kt_sign_in_submit'
                                  onClick={()=> handleClick8(i)}
                                  className='btn btn-primary'>Delete</button></td>
                                </tr>))}
                              </tbody>

                                    {/* end::Table body */}
                              </table>
                              {/* end::Table */}
                          </div>
                      </div>
                      {/* end::Tap pane */}
                      </div>
                  </div>              
                </div>}
                {/* end::Table 4 */} 
                </div>                             
              </div>
            </div>
          </div>                                    
          </div>

          {/* Campos solicitud */}
          <div className='fv-row mb-3'>
            {type_ctx === 'Connect'&& type_ctx.length !==0 && <div className='accordion' id='kt_accordion_4'>
            <div className='accordion-item'>
              <h2 className='accordion-header' id='kt_accordion_5_header_1'>
                <button
                  className='accordion-button fs-4 fw-bold collapsed'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#kt_accordion_5_body_1'
                  aria-expanded='false'
                  aria-controls='kt_accordion_5_body_1'
                >
                  Security
                </button>
              </h2>
              <div
                id='kt_accordion_5_body_1'
                className='accordion-collapse collapse'
                aria-labelledby='kt_accordion_5_header_1'
                data-bs-parent='#kt_accordion_5'
              >
                <div className='accordion-body'>
                    <>
                    <label className='form-check form-check-custom form-check-solid align-items-start'>
                    <input
                      className='form-check-input me-3 border border-gray-300'
                      type='checkbox'
                      name='email-preferences[]'   
                      value='Cloud Security Posture'     
                      onChange={handleCheckboxChangesecurity}   
                    />

                    <span className='form-check-label d-flex flex-column align-items-start'>
                      <span className='fw-bolder text-dark fs-5 mb-0'>Cloud Security Posture</span>
                    </span>
                  </label>
                  <div className='separator separator-dashed my-6'></div>
                  </>
                </div>
              </div>
            </div>
          </div>  } 

          
            
          </div>

          {/* Campos solicitud */}
          <div className='fv-row mb-3'>
            {type_ctx !== 'Connect'&& type_ctx.length !==0 && <div className='accordion' id='kt_accordion_4'>
            <div className='accordion-item'>
              <h2 className='accordion-header' id='kt_accordion_5_header_1'>
                <button
                  className='accordion-button fs-4 fw-bold collapsed'
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target='#kt_accordion_5_body_1'
                  aria-expanded='false'
                  aria-controls='kt_accordion_5_body_1'
                >
                  Security
                </button>
              </h2>
              <div
                id='kt_accordion_5_body_1'
                className='accordion-collapse collapse'
                aria-labelledby='kt_accordion_5_header_1'
                data-bs-parent='#kt_accordion_5'
              >
                <div className='accordion-body'>
                {Security.map((sec:any)=>(
                    <>
                    <label className='form-check form-check-custom form-check-solid align-items-start'>
                    <input
                      className='form-check-input me-3 border border-gray-300'
                      type='checkbox'
                      name='email-preferences[]'   
                      value={sec.name}     
                      onChange={handleCheckboxChangesecurity} 
                      
                    />
                    <span className='form-check-label d-flex flex-column align-items-start'>
                      <span className='fw-bolder text-dark fs-5 mb-0'>{sec.name}</span>
                    </span>
                  </label>
                  <div className='separator separator-dashed my-6'></div>
                  </>))}
                </div>
              </div>
            </div>
          </div>  } 

          </div>
          
          <div className='d-grid mb-10'>
            
           {/* <button
              type='button'
              disabled={counter >Number(Throughput)}
              id='kt_sign_in_submit'
              className={`btn btn-primary ${(counter >Number(Throughput))? 'btn-danger':''}`}
              onClick={handleSubmit}

            >
              {!loading && counter <Number(Throughput) ?<span className='indicator-label'>Send</span>:<span className='indicator-label'>The Total throughput exceeds the selected plan</span>}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
              </button>*/}
          </div>
          
          <div className='text-danger mt-2'>
            <ErrorMessage name='accountType' />
          </div>


    </div>
  )
}

